module.exports = __webpack_public_path__ + "static/media/loading2.e2ac473c.gif";